import LoginInput from "./LoginInput";

export default LoginInput;
